import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import './ColorSchemeToggle.scss';

const ColorSchemeToggle = ({ className = '' }) => {
    const { theme, colorScheme, setColorScheme } = useTheme();

    // Only show in dark mode
    if (theme !== 'dark') return null;

    return (
        <div className={`color-scheme-toggle ${className}`}>
            <button
                className={`color-swatch color-swatch--blue ${colorScheme === 'blue' ? 'active' : ''}`}
                onClick={() => setColorScheme('blue')}
                title="Blue theme"
                aria-label="Switch to Blue color scheme"
            >
                <span className="swatch-fill" />
            </button>
            <button
                className={`color-swatch color-swatch--purple ${colorScheme === 'purple' ? 'active' : ''}`}
                onClick={() => setColorScheme('purple')}
                title="Purple theme"
                aria-label="Switch to Purple color scheme"
            >
                <span className="swatch-fill" />
            </button>
        </div>
    );
};

export default ColorSchemeToggle;
